<template>
  <main>
    <transition-group mode="out-in" name="fade">
      <Preloader key="preloader" v-if="$store.state.loader" />
      <Hints key="hints" v-if="!$store.state.loader && $store.state.hints" />
    </transition-group>

    <Header />
    <div class="body">
      <Map :currentRoom="activeScheme" v-if="!$store.state.loader && initMap" />
      <transition mode="out-in" name="slide">
        <Sidebar key="sidebar" v-if="$store.state.sideHeroActive" />
      </transition>
      <transition
        @after-enter="afterEnterDrawer"
        @before-leave="onLeaveDrawer"
        mode="out-in"
        name="slide"
      >
        <DrawerList
          key="drawerlist"
          :drawerEnterEnd="drawerEnterEnd"
          @changeRoom="(index) => changeRoom(index)"
          v-if="$store.state.drawerListActive"
        />
      </transition>
    </div>
  </main>
</template>

<script>
import Map from "@/components/Map";
import axios from "axios";
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import DrawerList from "@/components/DrawerList";
import Preloader from "@/components/Loader";
import Hints from "@/components/Hints";
export default {
  name: "Home",
  components: { Hints, Preloader, DrawerList, Sidebar, Header, Map },
  data() {
    return {
      drawerEnterEnd: false,
      activeScheme: null,
    };
  },
  computed: {
    initMap() {
      return this.$store.state.popups.length > 0;
    },
  },
  async beforeCreate() {
    //showing preloader if client first time visited site
    const loc = localStorage.getItem("loaded_once");
    if (JSON.parse(loc)) {
      this.$store.commit("setLoad", false);
    }
  },
  async mounted() {
    await this.loadData();
    await this.loadImgs();
    const activeSidebarItemI = this.$router.currentRoute.params?.id;
    if (activeSidebarItemI) {
      this.$store.commit("setSidebar", true);
      this.$store.commit("setSelectedItem", Number(activeSidebarItemI));
      this.changeRoom(Number(activeSidebarItemI));
    }
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `/wp-json/wp/v2/locations?per_page=100`
        )
        .then((res) => {
          this.$store.commit("setLoadedPopups", res.data);
        })
        .catch(() => {});
    },
    async loadImgs() {
      const self = this;
      const imgs = ["/tour/img/map.webp", "/tour/img/map-scheme.png"];
      const mapSrc = new Image();
      mapSrc.src = imgs[0];
      mapSrc.onload = await async function () {
        const mapSchemeSrc = new Image();
        mapSchemeSrc.src = imgs[1];
        mapSchemeSrc.onload = await function () {
          self.$store.commit("setSourceLoadState", false);
          localStorage.setItem("loaded_once", "true");
        };
      };
    },
    afterEnterDrawer: function () {
      this.drawerEnterEnd = true;
    },
    onLeaveDrawer: function () {
      this.drawerEnterEnd = false;
    },
    changeRoom(index) {
      this.activeScheme = index;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/_variables";
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}
.slide-enter,
.slide-leave-to {
  transform: translate(200%, 0);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.body {
  position: relative;
  height: calc(100vh - #{$headerHeight});
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
main {
  height: 100%;
  width: 100%;
}
</style>
